import React from 'react'
import { Link as LinkBase } from 'react-router-dom'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  width: 100%;
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 32px 16px 48px;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding: 49px 38px;
    }
  }
`

export const GridContainer = styled(({ height, margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const JumboTitle = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  background-color: ${props => props.theme.palette.brand.gray3};
  padding: 4px;
  max-width: 322px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 27px;
  line-height: 32px;
  margin: 8px 0 0;

  ${props => props.theme.breakpoints.up('sm')} {
    margin: 57px 0 0;
  }
`

export const JumboDescription = styled('p')`
  display: inline-block;
  color: ${props => props.theme.palette.brand.black1};
  background-color: ${props => props.theme.palette.brand.gray3};
  padding: 4px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 19px;
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const Info = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: right;
`

export const Italic = styled('span')`
  font-style: italic;
`

export const Link = styled(LinkBase)`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 14px;
  text-decoration: none;
`
